<template>
    <div>
        <div>
            <br><br>
            <h3>{{ $t("posts.vehicleDescription") }}</h3>
            <el-row :gutter="20" class="surligneTitre">
                <el-col :span="6" v-if="post.millesime">{{$labels.millesime}} :</el-col>
                <el-col :span="6" v-if="post.millesime">{{post.millesime}}</el-col>

                <el-col :span="6" v-if="post.puissance_reelle">{{$labels.puissance_reelle}} :</el-col>
                <el-col :span="6" v-if="post.puissance_reelle">{{post.puissance_reelle}} ch</el-col>

                <el-col :span="6" v-if="post.mise_en_circulation">{{$labels.mise_en_circulation}} :</el-col>
                <el-col :span="6" v-if="post.mise_en_circulation">{{post.mise_en_circulation}}</el-col>

                <el-col :span="6" v-if="post.puissance_fiscale">{{$labels.puissance_fiscale}} :</el-col>
                <el-col :span="6" v-if="post.puissance_fiscale">{{post.puissance_fiscale}} ch</el-col>

                <el-col :span="6" v-if="post.kilometrage">{{$labels.kilometrage}} <span class="kilometrageGaranti">({{post.kilometrage_garanti? $t('posts.view.guaranteedMileage') : $t('posts.view.nonGuaranteedMileage') }})</span>  :</el-col>
                <el-col :span="6" v-if="post.kilometrage">{{post.kilometrage}} km</el-col>

                <el-col :span="6" v-if="post.garantie_libelle">{{$labels.garantie_libelle}} :</el-col>
                <el-col :span="6" v-if="post.garantie_libelle">{{post.garantie_libelle}}</el-col>

                <el-col :span="6" v-if="post.nb_portes">{{$labels.nb_portes}} :</el-col>
                <el-col :span="6" v-if="post.nb_portes">{{post.nb_portes}}</el-col>

                <el-col :span="6" v-if="post.garantie">{{$labels.garantie}} :</el-col>
                <el-col :span="6" v-if="post.garantie">{{post.garantie}} {{$t('general.month')}}</el-col>

                <el-col :span="6" v-if="post.couleur">{{$labels.couleur}} :</el-col>
                <el-col :span="6" v-if="post.couleur">{{post.couleur}} {{post.couleur_precision}}</el-col>

                <el-col :span="6" v-if="post.premiere_main">{{$labels.premiere_main}} :</el-col>
                <el-col :span="6" v-if="post.premiere_main">{{displayBoolean(post.premiere_main)}}</el-col>

                <el-col :span="6" v-if="post.boite_de_vitesse">{{$labels.boite_de_vitesse}} :</el-col>
                <el-col :span="6" v-if="post.boite_de_vitesse">{{post.boite_de_vitesse}}</el-col>

                <el-col :span="6" v-if="post.energie">{{$labels.energie}} :</el-col>
                <el-col :span="6" v-if="post.energie">{{post.energie}}</el-col>

                <el-col :span="6" v-if="isHybrideRechargeable">{{$labels.hybride_rechargeable}} :</el-col>
                <el-col :span="6" v-if="isHybrideRechargeable">{{displayBoolean(post.hybride_rechargeable)}}</el-col>

                <el-col :span="6" v-if="post.poids">{{$labels.poids}} :</el-col>
                <el-col :span="6" v-if="post.poids">{{post.poids}} kg</el-col>

            </el-row>
            <br><br>

        </div>
        <!--FIN Description du véhicule-->

        <div v-if="post.equipments">
            <h3>{{ $t("posts.edit.tabEquipments") }}</h3>
            <el-row :gutter="20"  class="surligneTitre">
                <el-col>{{post.equipments}}</el-col>
            </el-row>
            <br><br>
        </div>

        <div v-if="post.equipements_non_qualifies">
          <h3>{{ $t("posts.edit.otherEquipements") }}</h3>
          <el-row :gutter="20"  class="surligneTitre">
            <el-col>
                <span v-html="post.equipements_non_qualifies" style="white-space: pre-wrap;">
                      </span>
            </el-col>
          </el-row>
          <br>
        </div>

        <div v-if="post.commentaire_public_vo">
            <h3>{{ $t("posts.edit.otherInformation") }}</h3>
            <el-row :gutter="20"  class="surligneTitre">
                <el-col>
              <span v-html="post.commentaire_public_vo" style="white-space: pre-wrap;">
                    </span>
                </el-col>
            </el-row>
            <br>
        </div>

        <!--DEBUT Condition de vente-->
        <div class="grid-content bg-purple text-center surligneTitre" id="blockPrix">
          <div v-if="post.financement_mensualites">
            <strong v-if="post.devise_iso_4217 === 'EUR'">{{ post.financement_apport }} € + {{ post.financement_mensualites }} € / {{ $t('general.month') }}</strong>
            <strong v-else>{{ post.financement_apport }} {{post.devise_iso_4217}} + {{ post.financement_mensualites }} {{post.devise_iso_4217}} / {{ $t('general.month') }}</strong>
          </div>
          <div v-else>
            <strong v-if="post.devise_iso_4217 === 'EUR'">{{ post.prix }} €</strong>
            <strong v-else>{{ $t("posts.view.saleConditionsPriceVo", { price: post.prix}) }} {{post.devise_iso_4217}}</strong>
          </div>
        </div>
        <!--FIN Condition de vente-->
    </div>
</template>

<script>
import { mapState } from 'vuex'
import { getFromSnake } from '@/helpers/functions/getFromSnake'
import { hasHybrideRechargeable } from '@/helpers/posts/hasHybrideRechargeable'

export default {
  name: 'PostViewImmo',
  inject: ['browserContext'],
  props: ['post'],
  data () {
    return {
      photoAgrandit: null,
      photoPrincipale: null,
      showModal: false,
      emailDestinataire: null,
      commentaireEmail: this.$t('posts.view.sendByEmailComment')
    }
  },
  computed: {
    ...mapState('posts', ['filter']),
    user () {
      return this.$store.getters.getUser
    },
    sitimmoUser () {
      return this.$store.getters.getSitimmoUser
    },
    saisit_en_ligne () {
      return getFromSnake(this.sitimmoUser, 'saisit_annonces_en_ligne')
    },
    isHybrideRechargeable () {
      return hasHybrideRechargeable(this.post)
    }

  },
  methods: {
    displayBoolean (value) {
      if (value === true || value === 'oui') {
        return this.$t('general.yes')
      } else if (value === false || value === 'non') {
        return this.$t('general.no')
      }

      return null
    }
  }
}
</script>

<style>
    .surligneTitre{
        border-top:solid;
        border-color: #00b4cc;
        border-width: 1px;
    }

    #blockPrix {
      border: 1px solid #00b4cc;
      font-size: 30px;
    }

    .modal-header h3 {
        margin-top: 0;
        color: #42b983;
    }

    .kilometrageGaranti{
      font-size: 10px;
      font-weight: bold;
    }

</style>
